import { ReactElement, useState, useEffect, useRef } from 'react';
import Info from '@images/svg-icons/info.svg';
import Comic from '@images/svg-icons/comic.svg';

type RadioButton = {
    id: string;
    checked: boolean;
    label: string;
    border?: boolean;
    text?: any;
    value: string;
    onChange: Function;
    rightText?: string;
    hasTooltip?: boolean;
    toolTipText?: string;
    icon?: any;
    collectInStore: boolean;
}

const RadioButton = (props) : ReactElement => {
    
    const {
        id,
        label,
        checked,
        border,
        text,
        value,
        onChange,
        rightText,
        hasTooltip,
        toolTipText,
        icon,
        collectInStore
    } = props;

    const ref = useRef(null);

    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowTooltip(false);
            }
          };
          document.addEventListener('click', handleClickOutside, true);
          return () => {
            document.removeEventListener('click', handleClickOutside, true);
          };
      }, []);

    return (
        <div className={"radio-button" + (border ? ' bordered' : '') + (collectInStore ? ' collect-in-store' : '')}>
            <div className="radio-button-main">
                <div className="radio-button-left">
                    <div>
                        <input type="radio" id={id} name={id} value={value} checked={checked} onChange={(e) => onChange(e)}/>
                        <label htmlFor={id}>
                            <span></span>
                            {!!icon && icon}
                            {label}
                        </label>
                    </div>
                </div>
                {!!text && 
                    <div className="radio-button-center">{text}
                        {hasTooltip &&
                            <div ref={ref} className="radio-button-tooltip-container">
                                <button aria-label={'Open tooltip'} onClick={() => setShowTooltip(showTooltip => showTooltip = !showTooltip)}><Info/></button>
                                {showTooltip &&
                                    <div className="radio-button-tooltip">
                                        <div className="radio-button-tooltip-background">
                                            <Comic />
                                            <span tabindex="0" >
                                                { toolTipText }
                                            </span>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
            
            {!!rightText &&
                <div className="radio-button-right">
                    {rightText}
                </div>
            }
        </div>
    )
}

export default RadioButton;